import { FC } from 'react';
import { Tooltip as ReactTooltip, ITooltip } from 'react-tooltip';
import './Tooltip.scss';

export const Tooltip: FC<ITooltip> = (props: ITooltip) => {
	return (
		<ReactTooltip
			className="blk-ac-tooltip blk-ac-body-xs-bold"
			place={props.place || 'bottom'}
			opacity={1}
			offset={17}
			{...props}
		/>
	);
};

export default Tooltip;
